/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HitListRequest
 */
export interface HitListRequest {
    /**
     * Row ids of selected entities
     * @type {Array<string>}
     * @memberof HitListRequest
     */
    ids: Array<string>;
}

/**
 * Check if a given object implements the HitListRequest interface.
 */
export function instanceOfHitListRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ids" in value;

    return isInstance;
}

export function HitListRequestFromJSON(json: any): HitListRequest {
    return HitListRequestFromJSONTyped(json, false);
}

export function HitListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HitListRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ids': json['ids'],
    };
}

export function HitListRequestToJSON(value?: HitListRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ids': value.ids,
    };
}

